import { useTranslation } from "react-i18next"

export default function ProductInfoOrderWithin() {
    const { t } = useTranslation('productPage')
    return (
        <div className="pb-3">
            <strong className="d-block bi-clock-history">
                <span className="ps-2">{t('productInfo.orderWithin')}</span>
            </strong>
            <span id="deliveryTime">
                -
            </span>
            <strong className="d-block">{t('productInfo.toReceive')}</strong>
            -
        </div>
    )
}